export default __webpack_public_path__ + "img/doctorAvatar.1f2cdea9.svg";